import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ContractDataService } from '../shared/contractData.service';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-welcome-miet',
  templateUrl: './welcome-miet.component.html',
  styleUrls: ['./welcome-miet.component.css']
})
export class WelcomeMietComponent implements OnInit, AfterViewInit {
  userId: any = '';
  faArrowRight = faArrowRight;

  constructor(private route: ActivatedRoute, private router: Router, @Inject(ContractDataService) private contractDataService: ContractDataService) {
    const userId = this.route.snapshot.paramMap.get('userId');
    if(userId) {
      this.userId = userId;
      localStorage.setItem('userId', userId);
    }
  }

  ngOnInit() {
    this.contractDataService.changePage({ page: 'miet'});
    this.contractDataService.State = 0;
    if (this.contractDataService.getMietNaviBool()) {
      this.contractDataService.setMietNaviBool(false);
      this.router.navigate(['/mietvertrag/personaldata']);
    }
  }

  ngAfterViewInit() {
    const scrolloptions = { top: 0, left: 0 }
    window.scrollTo(scrolloptions);
  }

  gotoMasterData() {
    localStorage.setItem('primeType','miet');
    this.contractDataService.setContractPrimeType('miet');
    if(this.userId && this.userId !== '')
      this.router.navigate(['/mietvertrag/personaldata/'+this.userId]);
    else
      this.router.navigate(['/mietvertrag/personaldata']);
  }

}
